import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { reduxForm, Field, FormSection } from 'redux-form';
import {
  Button,
  ButtonToolbar,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Col,
  Nav,
  Label,
} from 'reactstrap';
import { v4 as uuid } from 'uuid';
import { addHours } from 'date-fns';
import ReactRouterPropTypes from 'react-router-prop-types';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';
import HourField from '../../../shared/components/form/HourField';
import DateField from '../../../shared/components/form/DateField';
import SmartCard from '../../../shared/components/SmartCard';
import {
  cnpjMasker,
  currencyMasker,
  cellPhoneMasker,
  phoneMasker,
  cepMasker,
} from '../../../shared/components/form/Masks';
import { INOUT, DAYS_WEEK } from '../../../shared/utils/constants';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import AboutSchoolSection from './AboutSchoolSection';
import Customization from './Customization';

const { format: formatDate } = require('date-fns');

const SchoolDataForm = (props) => {
  const {
    t,
    initialize,
    handleSubmit,
    change,
    school,
    handleSaveLogo,
    getReportPreview,
  } = props;

  const [workingDays, setWorkingDays] = useState([
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
  ]);

  const SCHOOL_DATA_TABS = {
    SCHOOLDATA: '1',
    SMARTGOCONFIG: '2',
    BILLINGDATA: '3',
    ABOUTSCHOOL: '4',
    CUSTOM: '5',
  };

  const [date, setDate] = useState({});
  const [calendarDate, setCalendarDate] = useState();
  const [activeTab, setActiveTab] = useState(SCHOOL_DATA_TABS.SCHOOLDATA);

  const onDaysWorkingChange = (event, index) => {
    if (event.target) {
      const updatedDays = [...workingDays];
      if (event.target.checked) {
        updatedDays[index] = INOUT.IN;
      } else {
        updatedDays[index] = INOUT.OUT;
      }
      setWorkingDays(updatedDays);
    }
  };

  const stringToArrayChar = (string) => {
    const arrChar = string.split(';');
    arrChar.pop();
    setWorkingDays(arrChar);
  };

  const formatCalendarDate = (dateProps) => {
    const formatedDate = formatDate(
      new Date(dateProps),
      'dd MMM, yyyy HH:mm:ss'
    );
    setCalendarDate(formatedDate);
  };

  const validateDate = (newDate, id) => {
    let updatedDate = { ...date };
    if (id === 0) {
      updatedDate = { ...date, start: newDate, end: addHours(newDate, 1) };
    } else {
      updatedDate = { ...date, end: newDate };
    }
    setDate(updatedDate);
  };

  useEffect(() => {
    initialize(school);
    if (school) {
      stringToArrayChar(school.workingDays);
      formatCalendarDate(school.contractingDate);
    }
  }, [school]);

  useEffect(() => {
    change('workingDays', workingDays);
  }, [workingDays]);

  const toggleTab = (index) => {
    setActiveTab(index);
  };

  const showCustomizationVariables = () => {
    return activeTab === SCHOOL_DATA_TABS.CUSTOM && school;
  };

  return (
    <Fragment>
      <SmartCard>
        <form className="form" onSubmit={handleSubmit}>
          <Col md={12} lg={12} xl={12}>
            <div className="tabs tabs--justify tabs--bordered-bottom">
              <div className="tabs__wrap">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === SCHOOL_DATA_TABS.SCHOOLDATA,
                      })}
                      onClick={() => {
                        toggleTab(SCHOOL_DATA_TABS.SCHOOLDATA);
                      }}
                    >
                      {t('school_data.title')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === SCHOOL_DATA_TABS.SMARTGOCONFIG,
                      })}
                      onClick={() => {
                        toggleTab(SCHOOL_DATA_TABS.SMARTGOCONFIG);
                      }}
                    >
                      {t('school_data.title_smartgo')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === SCHOOL_DATA_TABS.BILLINGDATA,
                      })}
                      onClick={() => {
                        toggleTab(SCHOOL_DATA_TABS.BILLINGDATA);
                      }}
                    >
                      {t('school_data.title_selected_plan')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === SCHOOL_DATA_TABS.ABOUTSCHOOL,
                      })}
                      onClick={() => {
                        toggleTab(SCHOOL_DATA_TABS.ABOUTSCHOOL);
                      }}
                    >
                      {t('school_data.about-school')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === SCHOOL_DATA_TABS.CUSTOM,
                      })}
                      onClick={() => {
                        toggleTab(SCHOOL_DATA_TABS.CUSTOM);
                      }}
                    >
                      {t('school_data.custom')}
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={SCHOOL_DATA_TABS.SCHOOLDATA} className="form">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('school_data.reason_name')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="reasonName"
                          type="text"
                          component={renderField}
                          maxLength="150"
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('school_data.fantasy_name')}
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="fantasyName"
                          type="text"
                          component={renderField}
                          maxLength="100"
                        />
                      </div>
                    </div>
                    <div className="form__form-group--2_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.cnpj')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="cnpj"
                            type="text"
                            component={renderField}
                            {...cnpjMasker()}
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.subscription')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="subscription"
                            type="text"
                            component={renderField}
                            maxLength="30"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('school_data.responsible')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="responsible"
                          type="text"
                          component={renderField}
                          maxLength="50"
                        />
                      </div>
                    </div>
                    <div className="form__form-group--2_columns">
                      <div className="form__form-group col-md-1">
                        <span className="form__form-group-label">
                          {t('address.zip-code')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="zipCode"
                            type="text"
                            component={renderField}
                            {...cepMasker()}
                            placeholder={t('placeholder.student.zipCode')}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('address.address')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="address"
                            type="text"
                            component={renderField}
                            maxLength="200"
                            placeholder={t('placeholder.student.address')}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form__form-group--2_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('address.number')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="addressNumber"
                            type="text"
                            component={renderField}
                            maxLength="25"
                            placeholder={t('placeholder.student.addressNumber')}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('address.neighborhood')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="neighborhood"
                            type="text"
                            component={renderField}
                            maxLength="100"
                            placeholder={t('placeholder.student.neighborhood')}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form__form-group--2_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('address.state')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="uf.label"
                            type="text"
                            component={renderField}
                            placeholder={t('placeholder.student.state')}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('address.city')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="globalCity.label"
                            type="text"
                            component={renderField}
                            placeholder={t('placeholder.student.city')}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form__form-group--3_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">{`${t(
                          'phone.cellphone'
                        )} 01`}</span>
                        <div className="form__form-group-field">
                          <Field
                            name="phoneOne"
                            type="text"
                            component={renderField}
                            placeholder={t('placeholder.student.cellPhone')}
                            {...cellPhoneMasker()}
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">{`${t(
                          'phone.cellphone'
                        )} 02`}</span>
                        <div className="form__form-group-field">
                          <Field
                            name="phoneTwo"
                            type="text"
                            component={renderField}
                            placeholder={t('placeholder.student.cellPhoneAux')}
                            {...cellPhoneMasker()}
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('phone.phone')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="phoneResponsible"
                            type="text"
                            component={renderField}
                            {...phoneMasker()}
                            placeholder={t('placeholder.student.phone')}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('general.email')}
                      </span>
                      <div className="form_form-group-field">
                        <Field
                          name="email"
                          type="email"
                          component={renderField}
                          maxLength="100"
                        />
                      </div>
                    </div>
                    <div className="form__form-group--3_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.startTime')}
                        </span>
                        <div className="form_form-group-field">
                          <Field name="startTime" component={HourField} />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.finalTime')}
                        </span>
                        <div className="form_form-group-field">
                          <Field name="finalTime" component={HourField} />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.days_useful')}
                        </span>
                        <div className="form__form-group-field pad-tb10">
                          {workingDays.map((day, index) => (
                            <div
                              key={uuid()}
                              className="d-flex form__form-group-input-wrap--error-above"
                            >
                              <Label className="generic__label">
                                {t(
                                  `general.weekdays.letter.${DAYS_WEEK[index]}`
                                )}
                              </Label>
                              <Field
                                name={DAYS_WEEK[index]}
                                component={renderCheckBoxField}
                                className="colored-click"
                                defaultChecked={day === '1'}
                                onChange={(event) => {
                                  onDaysWorkingChange(event, index);
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane
                    tabId={SCHOOL_DATA_TABS.SMARTGOCONFIG}
                    className="form"
                  >
                    <FormSection name="smartGoSettings">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.config_distance')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="smartGoDistance"
                            type="number"
                            component={renderField}
                            maxLength="5"
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.config_time')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="smartGoTime"
                            type="number"
                            component={renderField}
                            maxLength="5"
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.google-api-key')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="googleApiKey"
                            type="text"
                            component={renderField}
                          />
                        </div>
                      </div>
                    </FormSection>
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane
                    tabId={SCHOOL_DATA_TABS.BILLINGDATA}
                    className="form"
                  >
                    <div className="form__form-group--3_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.contractedPlan')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="contractedPlan"
                            type="text"
                            component={renderField}
                            maxLength="100"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.activeStudents')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="activeStudents"
                            type="number"
                            component={renderField}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.contractingDate')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="contractingDate"
                            component={DateField}
                            selected={calendarDate}
                            onChange={(values) => validateDate(values, 0)}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form__form-group--3_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.surplusPerStudent')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="surplusPerStudent"
                            type="text"
                            component={renderField}
                            {...currencyMasker()}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.monthlyValue')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="monthlyValue"
                            type="text"
                            component={renderField}
                            {...currencyMasker()}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('school_data.current_value')}
                        </span>
                        <div className="form_form-group-field">
                          <Field
                            name="currentValue"
                            type="text"
                            component={renderField}
                            {...currencyMasker()}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane
                    tabId={SCHOOL_DATA_TABS.ABOUTSCHOOL}
                    className="form"
                  >
                    <AboutSchoolSection />
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={SCHOOL_DATA_TABS.CUSTOM} className="form">
                    {showCustomizationVariables() && (
                      <Customization
                        school={school}
                        handleSaveLogo={handleSaveLogo}
                        getReportPreview={getReportPreview}
                      />
                    )}
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </Col>
          <ButtonToolbar className="form__button-toolbar">
            <Button color="success" type="submit">
              {t('general.save')}
            </Button>
          </ButtonToolbar>
        </form>
      </SmartCard>
    </Fragment>
  );
};
SchoolDataForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleSaveLogo: PropTypes.func.isRequired,
  getReportPreview: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  school: PropTypes.shape({
    id: PropTypes.number,
    customizationVariables: PropTypes.shape({}),
    workingDays: PropTypes.string,
    contractingDate: PropTypes.instanceOf(Date),
    logoUrl: PropTypes.string.isRequired,
  }).isRequired,
};

export default reduxForm({
  form: 'DataSchoolForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(SchoolDataForm));
